import { RpcObservableRequestContext } from '../rpc-observable-request';
import { RpcObservableResultContext } from '../rpc-observable-result';

/**
 * RPC elevate request name and version.
 */
export class RpcObservableElevateKey {
    public static command = 'ElevateObservable';
    public static version = '0.1.0';
}

/**
 * Rpc observable elevate request data.
 */
export type RpcObservableElevateRequest = RpcObservableRequestContext;

/**
 * Rpc observable elevate response data.
 */
export interface RpcObservableElevateResult extends RpcObservableResultContext {
    elevated: boolean;
}

/**
 * Rpc observable elevate error data.
 */
export interface RpcObservableElevateError extends RpcObservableResultContext {
    error: string;
}
